const rootEl = document.getElementById('root');

const parentShouldScroll = element => {
  if (!element) {
    return false;
  }
  if (element.classList.contains('u-allow-scrolling') || element.classList.contains('reveal')) {
    return true;
  } else {
    return parentShouldScroll(element.parentElement);
  }
};

const touchPreventDefault = event => {
  if (event.touches.length > 1) {
    event.preventDefault();
  } else if (!parentShouldScroll(event.target)) {
    event.preventDefault();
  }
};

// disable pinch zoon
document.documentElement.addEventListener('touchmove', touchPreventDefault, { passive: false });
document.body.addEventListener('touchmove', touchPreventDefault, { passive: false });

// macOS pinch zoom gesture
window.addEventListener('gesturestart', e => e.preventDefault());
window.addEventListener('gesturechange', e => e.preventDefault());
window.addEventListener('gestureend', e => e.preventDefault());

rootEl.addEventListener('gesturestart', e => e.preventDefault());
rootEl.addEventListener('gesturechange', e => e.preventDefault());
rootEl.addEventListener('gestureend', e => e.preventDefault());
